import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	columnActions: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.column-actions',
		defaultMessage: 'More actions for {column}',
		description:
			'Accessible label for an icon-only button that (when clicked) displays a dropdown list of column actions for a table',
	},
	sortAsc: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-asc',
		defaultMessage: 'Sort in ascending order',
		description:
			'Text for an action that allows the user to sort a list of items in ascending order',
	},
	sortDesc: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-desc',
		defaultMessage: 'Sort in descending order',
		description:
			'Text for an action that allows the user to sort a list of items in descending order',
	},
	sortCustom: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom',
		defaultMessage: 'Sort {sortDescription}',
		description:
			'Text for an action that allows the user to sort a list of items – sortDescription is like "A -> Z"',
	},
	sortCustomNew: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-custom-new',
		defaultMessage:
			'Sort {sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}',
		description:
			'Text for an action that allows the user to sort a list of items – sortDescription is like "A -> Z"',
	},
	sortDirection: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-direction',
		defaultMessage:
			'{sortDescription, select, a_to_z {A to Z} z_to_a {Z to A} oldest_to_newest {oldest to newest} newest_to_oldest {newest to oldest} lowest_to_highest {lowest to highest} highest_to_lowest {highest to lowest} other {{sortDescription}}}',
		description:
			'Text for an action that allows the user to sort a list of items – sortDescription is like "A -> Z"',
	},
	clearSorting: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.clear-sorting',
		defaultMessage: 'Clear sorting',
		description: 'Text for an action that allows the user to clear sorting from a list of items',
	},
	sortByColumns: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.sort-by-columns',
		defaultMessage: 'Sort by columns',
		description:
			'Text for a group of dropdown actions that allows the user to sort a list of items by columns',
	},
	moveFirst: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first',
		defaultMessage: 'Move column to the first position',
		description:
			'Text for an action that allows the user to move a table column to the first position',
	},
	moveLeft: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left',
		defaultMessage: 'Move column to the left',
		description: 'Text for an action that allows the user to move a table column to the left',
	},
	moveRight: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right',
		defaultMessage: 'Move column to the right',
		description: 'Text for an action that allows the user to move a table column to the right',
	},
	moveLast: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last',
		defaultMessage: 'Move column to the last position',
		description:
			'Text for an action that allows the user to move a table column to the last position',
	},
	moveFirstNew: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-first-new',
		defaultMessage: 'Move column to first position',
		description:
			'Text for an action that allows the user to move a table column to the first position',
	},
	moveLeftNew: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-left-new',
		defaultMessage: 'Move column to left',
		description: 'Text for an action that allows the user to move a table column to the left',
	},
	moveRightNew: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-right-new',
		defaultMessage: 'Move column to right',
		description: 'Text for an action that allows the user to move a table column to the right',
	},
	moveLastNew: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.move-last-new',
		defaultMessage: 'Move column to last position',
		description:
			'Text for an action that allows the user to move a table column to the last position',
	},
	removeColumn: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.remove-column',
		defaultMessage: 'Remove column',
		description: 'Text for an action that allows the user to remove a column from a table',
	},
	resizeColumn: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.resize-column',
		defaultMessage: 'Resize column',
		description: 'Text for an action that allows the user to resize the width of a table column',
	},
	resetColumnWidth: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.reset-column-width',
		defaultMessage: 'Reset column width',
		description:
			'Text for an action that allows the user to reset a table column to its default width',
	},
	editField: {
		id: 'native-issue-table.issue-table.header.header-cell.header-cell-actions.more-actions.edit-field',
		defaultMessage: 'Edit field',
		description:
			'Text for an action that allows the user to edit the config of the underlying field of this column',
	},
});
